import {Component, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DatePipe} from '@angular/common';
import {CompanyDataService} from '@services/company-data.service';
import {ICompany, ITaxCalendar} from '@models/company.interface';
import {ICompteAdministration} from '@models/compteAdministration.interface';
import {AlertCircle, Calendar, Clock, Landmark, LucideAngularModule} from '@shared/components/icons/google-icons';

@Component({
  selector: 'app-company-dossier-fiscal',
  imports: [DatePipe, LucideAngularModule],
  templateUrl: './company-dossier-fiscal.html',
})
export class CompanyDossierFiscal implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly companyData = inject(CompanyDataService);

  compteAdministration: WritableSignal<ICompteAdministration | null> = signal(null);
  company: WritableSignal<ICompany> = signal({} as ICompany);
  taxCalendar: WritableSignal<ITaxCalendar[]> = signal([]);

  protected readonly Landmark = Landmark;
  protected readonly Calendar = Calendar;
  protected readonly AlertCircle = AlertCircle;
  protected readonly Clock = Clock;

  ngOnInit() {
    const siret = this.route.parent!.snapshot.paramMap.get('siret')!;
    this.companyData.load(siret).subscribe(c => {
      this.compteAdministration.set(c);
      this.company.set(c.company);
      this.taxCalendar.set(c.company.taxCalendar ?? []);
    });
  }

  hasConfiguredCredentials(service: 'impots'): boolean {
    const compte = this.compteAdministration();
    if (!compte) {
      return false;
    }
    return compte.mdpSecretImpotsGouv != null;
  }
}
